import React, { useEffect, useState, useMemo, useCallback, useRef  } from "react";
import { useAuth } from '../utils/AuthContext';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getCommunitiesPaginated } from "../api/community.js";
import { useParams } from "react-router-dom";
import Loading from '../components/loading/Loading';
import CommunityForm from "../components/CommunityForm.jsx";
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Community.css";

export default function DashboardMessages() {
  const { user } = useAuth();
  const { lang } = useParams();
  const [setlang, setLang] = useState("fa")
  const [consoleError, setConsoleError] = useState("");
  const [loading, setLoading] = useState(true);
  const [newcommunities, setNewCommunities] = useState([]);
  const [newcomModal, setnewcomModal] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const pageSize = 9; 

  const handleCommunityCreated = (newCommunity) => {
    setNewCommunities([...newcommunities, newCommunity]);
  };

  const [community, setCommunity] = useState(null);
  const [topics, setTopics] = useState([]);
  const [selectedTopic, setSelectedTopic] = useState(null);

  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, loading, navigate, location]);

  useEffect(() => {
    const fetchCommunityData = async () => {
      setLoading(true);

      try {
        const res = await getCommunitiesPaginated();
        const data = Array.isArray(res) ? res : res.results || [];
        const totalPages = Math.ceil(data.length / pageSize);
        const startIndex = (page - 1) * pageSize;
        const endIndex = startIndex + pageSize;
        const paginated = data.slice(startIndex, endIndex);
        setCommunity(paginated);
        setTotalPages(totalPages);

      } catch (err) {
        setConsoleError("Failed to load community data:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCommunityData();
  }, [page, pageSize]);

  const handleNewcom = () => {
    setnewcomModal(true);
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  
  // Handle loading state
  if (loading) return <Loading />;  

  if (!community) {
    return (
      <>
        <NavbarLog />
          <div>{setlang==="en"?"Community page not found.":"این فضای گفتگو دیگر وجود ندارد"}</div>
        <Footer />
      </>
    );
  }

  return (
  <>
    <NavbarLog />
    {/*<div className="community-show">
      <img src={communityShow}/>
    </div>*/}
    <div className="community-page">
      <div className="community-detail">
        <h1 style={{direction:"rtl"}}>{setlang === "en"? "BidZone Community":"جامعه BidZone"}</h1>
        {/*<button onClick={() => handleNewcom()}>Create new community</button>*/}

        <div className="community-list">
          <div className="community-card">
            {community.map((c) => (
              <li className="" key={c.id} >
                <Link to={`/${lang}/community/${c.id}`}>
                  <header
                    className="community-header"
                    style={{
                      backgroundImage: `url(${c.image_url || "" })`,
                    }}
                    ></header>
                </Link>

                <h3>{c.name}</h3>
                <p className="community-desc">{c.description}</p>
                <Link to={`/${lang}/community/${c.id}`}>
                  {setlang === "en"? "View Community →":"مشاهده موضوع →"}
                </Link>

              {/* 
              {Array.isArray(c.topics) && c.topics.length > 0 ? (
                <ul>
                  {c.topics.map((topic) => (
                    <li key={topic.id}>
                      <span>{topic.title}</span>
                      {topic.description}
                    </li>
                  ))}
                </ul>
              ):(
                <p>No topics yet in this community.</p>
              )}
              */}

              </li>
            ))}
          </div>

          {/* Pagination controls */}
          <div className='pagination-controls-community'>
            <button
              disabled={page <= 1}
              onClick={() => setPage((prev) => prev - 1)}
            >
              {setlang === "en"? "Previous":"قبلی"}
            </button>
            {setlang === "en"?
            <span>
              <small>
                Page {page} of {totalPages>0?totalPages:1}
              </small>
            </span>:
            <span>
              <small>
                صفحه {page} از {totalPages>0?totalPages:1}
              </small>
            </span>
            }
            <button
              disabled={page >= totalPages}
              onClick={() => setPage((prev) => prev + 1)}
            >
              {setlang === "en"? "Next":"بعدی"}
            </button>
          </div>

          {/* Topics Tabs */}
          <div>
            {topics.map((topic) => (
              <button
                key={topic.id}
                onClick={() => setSelectedTopic(topic.id)}
                className={`px-4 py-2 whitespace-nowrap ${
                  selectedTopic === topic.id
                    ? "border-b-2 border-blue-600 text-blue-600 font-semibold"
                    : "text-gray-600 hover:text-blue-600"
                }`}
              >
                {topic.title}
              </button>
            ))}
          </div>
        </div>

        {newcomModal && (
          <div className="modal-overlay"> 
            <div className="modal-content"> 
              <CommunityForm
                onCreated={handleCommunityCreated}
                onClose={() => setnewcomModal(false)}
                onCancel={() => {   
                  setnewcomModal(false); 
                }}
                setlang={setlang}
              />
            </div>
          </div>
        )}

      </div>
    </div>
    <Footer />
  </>
  );
}